import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import {TEticketEvent} from '../../../redux/eTicket/eTicket.type';
import {toUnixSec} from '../../../library/dates';
import {formatDecimal} from '../../../library/numberFunction';

dayjs.extend(utc);

export const buildNavigationUrl = (location: string) =>
    `https://waze.com/ul?q=${encodeURIComponent(location)}`;

const toCalendarDate = (ts: number) => dayjs.unix(ts).utc().format('YYYYMMDDTHHmmss[Z]');

export const buildCalendarUrl = (event: TEticketEvent) => {
    const params = new URLSearchParams({action: 'TEMPLATE', text: event.title});
    if(event.location) params.set('location', event.location);
    const start = toUnixSec(event.timeStart);
    if(!Number.isNaN(start)) {
        const explicitEnd = toUnixSec(event.timeEnd);
        const end = !Number.isNaN(explicitEnd) && explicitEnd > start ? explicitEnd : dayjs.unix(start).add(2, 'hour').unix();
        params.set('dates', `${toCalendarDate(start)}/${toCalendarDate(end)}`);
    }
    return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const openUrl = (url?: string) => {
    if(url) window.open(url, '_blank', 'noopener');
};

export const hasCharge = (price?: string) => {
    if(!price) return false;
    return parseFloat(price.replace(/[^\d.-]/g, '')) > 0;
};

/* The API sends an amount as "₪1500" — the symbol stays where it is, only the digits get grouped */
export const formatAmount = (amount: string) => amount.replace(/\d+(?:\.\d+)?/, digits => formatDecimal(digits));
